import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@mlb/react-patterns/components/Icon/icon.tsx';

import {
    List,
    Item,
    ItemText,
    RemoveItemButton,
} from './SavedList.styles';

const SavedList = (props) => {

    const {
        selected,
        onRemoveItemButtonClick,
    } = props;

    return (
        <List>
            {selected.map((item, index) => (
                <Item
                    data-item-index={index}
                    key={`typeahead-saved-list-item-${index}`}
                    data-item-value={item.value}
                >
                    <ItemText>{item.label}</ItemText>
                    <RemoveItemButton
                        onClick={() => {

                            onRemoveItemButtonClick(item);

                        }}
                    >
                        <Icon
                            name={'close'}
                            width={12}
                        />
                    </RemoveItemButton>
                </Item>
            ))}
        </List>
    );

};

SavedList.propTypes = {
    selected: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        }).isRequired
    ).isRequired,
    onRemoveItemButtonClick: PropTypes.func.isRequired,
};

export default SavedList;
